import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Formik, Field, Form } from "formik"
import { Redirect, Link } from "react-router-dom"
import fields from "models/floorplan"
import NumberField from "components/NumberField"
import TextArea from "components/TextArea"
import KeyValueField from "components/KeyValueField"
import TableRowField from "components/TableRowField"
import { toast } from "react-toastify"
import * as Yup from "yup"
import _ from "lodash"
import Title from "../general/title"
import ReactSelect from "components/ReactSelect"
import nullToEmptyString from "helpers/nullToEmptyString"
import clone from "clone"
import Dropzone from "react-dropzone"
import settings from "settings"
import request from "superagent"
import FullTable from "components/FullTable"
import { GridContextProvider, GridDropZone, GridItem, swap } from "react-grid-dnd"
import helpers from "helpers/helpers"
import getData from "helpers/asyncSubmitData"

//todo Redo this component to be a functional component when time permits.
class EditFloorplan extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			modal: false,
			fields,
			elevationFields: {
				elevations: [],
			},
			id: parseInt(this.props.match.params.id),
			images: [],
			blueprints: [],
			columns: [
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Community",
					accessor: "propertyName",
					filterMethod: (f, r) => helpers.tableText(f, r, "propertyName"),
				},
				{
					Header: "Min Sq Ft",
					accessor: "min_sqft",
				},
				{
					Header: "Min Sq Ft",
					accessor: "max_sqft",
				},
			],
			masterCols: [
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Approval Status",
					accessor: "approved",
					filterable: false,
				},
				{
					Header: "Approval Comments",
					accessor: "comments",
					filterable: false,
				},
				{
					Header: "Rejection Reason",
					accessor: "rejection_reason",
					filterable: false,
				},
				{
					Header: "Current File",
					accessor: "current",
				},
				{
					Header: "Edit",
					accessor: "edit",
				},
			],
			lotCols: [
				{
					Header: "Community",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Sq. Ft",
					accessor: "sqft",
				},
				{
					Header: "Stories",
					accessor: "stories",
				},
				{
					Header: "Beds",
					accessor: "beds",
				},
				{
					Header: "Full Baths",
					accessor: "full_baths",
				},
				{
					Header: "Half Baths",
					accessor: "half_baths",
				},
				{
					Header: "Garage",
					accessor: "garage",
				},
			],
		}
	}

	async componentDidMount() {
		await this.retrieveData()
	}

	async componentDidUpdate(prevProps, prevState) {
		// This used to just be prevProps, this.props, but the build data was commented out.  Put in more specific elevations change to refresh builddata.  This is needed so when you put in a new elevation and hit submit that the new on you put in there stays through the refresh on payload.  If commenented out the new row disappears when you hit submit.
		if (!_.isEqual(prevProps?.payload?.public?.elevations, this?.props?.payload?.public?.elevations)) {
			await this.buildData()
		}
	}

	buildData = async (data) => {
		let id = parseInt(this.props.match.params.id)
		let elevationFields = {}
		elevationFields.elevations = _.filter(this.props.payload.public.elevations, (v) => v.floorplan == id)
		data = nullToEmptyString(data)
		if (!data.lot_types) data.lot_types = []
		let images = data.files ? clone(data.files) : []
		let blueprints = data.blueprints ? clone(data.blueprints) : []
		this.setState({ fields: data, elevationFields, images, blueprints }, () => {
			//console.log(this.state)
		})
	}

	retrieveData = async () => {
		this.props.loadingStatus(true)
		return getData("getFloorplan", {
			id: parseInt(this.props.match.params.id),
		})
			.then((resp) => {
				this.buildData(resp.data)
				this.props.loadingStatus(false)
			})
			.catch((e) => {
				console.log(e)
				this.props.loadingStatus(false)
			})
	}

	validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			feed_name: Yup.string().notRequired(),
			feed_name_secondary: Yup.string().notRequired(),
			builder: Yup.number().required("Required"),
			//sqft: Yup.number().required("Required"),
			//price: Yup.number().notRequired(),
			//stories: Yup.number().required("Required"),
			//beds: Yup.number().required("Required"),
			//full_baths: Yup.number().required("Required"),
			status: Yup.number().required("Required"),
			//garage: Yup.number().required("Required"),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	onDrop = (files, f, type) => {
		// Type is whether this is a blueprint or general image.
		const req = request.post(`${settings.ep}/inputFloorplanImage`)
		for (let v of files) {
			req.attach(v.name, v)
		}
		//req.attach(files[0].name, files[0])
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.field("attributes", JSON.stringify({ floorplan_id: this.state.id }))
		req.field("type", type)
		req.end((err, response) => {
			//return
			let resp = response.body
			//console.log(resp)
			//return
			if (err) {
				console.log(err)
			}
			if (resp.status == 200) {
				toast.success(resp.message)
				let state = clone(this.state)
				if (type == "blueprints") {
					state.blueprints = resp.data
					f.setFieldValue("blueprints", resp.data)
				} else {
					state.images = resp.data
					f.setFieldValue("files", resp.data)
				}
				this.setState(state, () => {
					//console.log(this.state)
				})
			}
		})
	}

	onDropMaster = (files, property) => {
		this.props.loadingStatus(true)
		const req = request.post(`${settings.ep}/replaceMasterPlan`)
		req.attach(files[0].name, files[0])
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.field("data", JSON.stringify({ floorplan_id: this.state.id, property }))
		req.end((err, response) => {
			let resp = response.body
			if (err) {
				console.log(err)
			}
			if (resp.status == 200) {
				toast.success(resp.message)
				let state = _.cloneDeep(this.state)
				state.fields.arc_file = resp.data
				this.props.loadingStatus(false)
				this.setState(state, () => {})
				//this.props.getPayload()
			}
		})
	}

	removeImage = (k, f, type) => {
		let set
		if (type == "general") set = this.state.images
		else if (type == "blueprints") set = this.state.blueprints
		let images = _.clone(set)
		images.splice(k, 1)
		if (type == "general") {
			this.setState({ images })
			f.setFieldValue("files", images)
		} else if (type == "blueprints") {
			this.setState({ blueprints: images })
			f.setFieldValue("blueprints", images)
		}
		this.props.loadingStatus(true)
		let values = {
			images,
			type: "floorplan",
			id: this.state.id,
			bucket: type, // This is general vs blueprints
		}
		submitData("removeImage", values).then((data) => {
			toast.success(data.message)
			this.props.loadingStatus(false)
		})
	}

	compileThumbs = (f, type) => {
		const arrayMove = require("array-move")
		let set
		if (type == "general") set = this.state.images
		else if (type == "blueprints") set = this.state.blueprints
		const onChange = (sourceId, sourceIndex, targetIndex) => {
			//console.log(sourceId, sourceIndex, targetIndex)
			let images = _.clone(set)
			images = arrayMove(images, sourceIndex, targetIndex)
			if (type == "general") {
				this.setState({ images })
				f.setFieldValue("files", images)
			} else if (type == "blueprints") {
				this.setState({ blueprints: images })
				f.setFieldValue("blueprints", images)
			}
		}
		let rows = Math.ceil(set.length / 4)
		let height = rows * 235
		return (
			<GridContextProvider onChange={onChange}>
				<GridDropZone
					id="items"
					boxesPerRow={6}
					rowHeight={225}
					style={{ height: `${height}px`, width: "100%" }}>
					{set.map((item, k) => {
						let url
						if (item.url && item.url.includes("http")) {
							url = item.url
						} else {
							url = `${settings.s3}${item}`
						}
						// Parantheses in filename break image thumbnail
						url = url.replace(/\(/g, "%28").replace(/\)/g, "%29")
						let icon = (
							<div
								className="imageZone__thumb"
								key={`thumb` + item}
								style={{
									backgroundImage: `url(${url})`,
								}}>
								<i
									className="fas fa-times-circle formFiles__removeIcon"
									onClick={() => this.removeImage(k, f, type)}></i>
							</div>
						)
						return (
							<GridItem key={k} className="imageZone__block">
								<div
									style={{
										width: "100%",
										height: "100%",
										paddingBottom: "20px",
										paddingRight: "20px",
									}}>
									{icon}
								</div>
							</GridItem>
						)
					})}
				</GridDropZone>
			</GridContextProvider>
		)
	}

	tableRows = (f) => {
		let rows = []
		_.forEach(this.state.fields.properties, (v) => {
			try {
				let p = _.find(this.props.payload.public.properties, { id: v })
				if (!p) throw "Cannot Find Property"
				rows.push(
					<tr key={p.id}>
						<td>{p.name}</td>
						<td>
							<NumberField
								name={`base_prices.${p.id}`}
								value={f.values.base_prices[p.id]}
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								thousandSeparator={true}
								numeric={true}
							/>
						</td>
					</tr>
				)
			} catch (er) {
				console.log(er)
			}
		})
		return rows
	}

	buildMasterPlans = (f) => {
		let ret = []
		_.forEach(this.state.fields.arc_approved, (v, k) => {
			let index = _.findIndex(this.state.fields.arc_file, { property: v.property })
			//if (index == -1) return
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let comments = _.get(f.values, `arc_approved[${k}].approval_comments`)
			let rejection_reason = _.get(f.values, `arc_approved[${k}].rejection_reason`)
			let curFile = "Not Available"
			let approvedStatus
			if (index !== -1) {
				let url = this.state.fields.arc_file[index].file
				url = url.replace("+", "%2B")
				curFile = (
					<a href={`${settings.s3}${url}`} className="btn-square" target="_blank">
						View File
					</a>
				)
			}
			if (_.has(f.values, `arc_approved[${k}].approved`)) {
				approvedStatus = _.get(f.values, `arc_approved[${k}].approved`)
			}
			ret.push({
				property: property ? property.name : "",
				approved: (
					<ReactSelect
						name={`arc_approved[${k}].approved`}
						options={[
							{ value: false, label: "Not Approved" },
							{ value: true, label: "Approved" },
						]}
						value={approvedStatus}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
					/>
				),
				comments: (
					<TextArea
						name={`arc_approved[${k}].approval_comments`}
						className="form__textarea"
						value={comments ? comments : ""}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.description}
						error={f.errors.description}
					/>
				),
				rejection_reason: (
					<TextArea
						name={`arc_approved[${k}].rejection_reason`}
						className="form__textarea"
						value={rejection_reason ? rejection_reason : ""}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.description}
						error={f.errors.description}
					/>
				),
				current: curFile,
				edit: (
					<Dropzone
						multiple={false}
						onDrop={(files) => {
							this.onDropMaster(files, v.property)
						}}>
						{({ getRootProps, getInputProps }) => (
							<section className="dropzone">
								<div {...getRootProps()} className="dropbox__cont">
									<input {...getInputProps()} />
									<p className="dropzone__action">Drag 'n' drop new PDF here</p>
								</div>
							</section>
						)}
					</Dropzone>
				),
			})
		})
		return ret
	}

	buildLotsTable = (type) => {
		let data = []
		// List of builders in selected communities
		let lots = _.filter(this.props.payload.exec.lots, (v) => v.floorplan == this.state.id)
		_.forEach(lots, (v) => {
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			data.push({
				property: property ? property.name : "",
				address: v.address,
				sqft: v.sqft,
				stories: v.stories,
				beds: v.beds,
				full_baths: v.full_baths,
				half_baths: v.half_baths,
				garage: v.garage,
			})
		})
		return data
	}

	buildClassifications = (f) => {
		if (this.props.payload?.public?.floorplan_classifications?.length === 0) return null
		let classifications = []
		_.forEach(this.props.payload.public.floorplan_classifications, (v) => {
			classifications.push({ label: v.name, value: v.id })
		})
		if (classifications.length > 0) {
			return (
				<li className={fieldStatus("classifications", f)}>
					<label htmlFor="classifications">Classifications</label>
					{f.errors.classifications && f.touched.classifications && (
						<div className="form__message">{f.errors.classifications}</div>
					)}
					<ReactSelect
						name={`classifications`}
						options={classifications}
						isMulti
						value={f.values.classifications}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
					/>
				</li>
			)
		}
		return null
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			return (
				<div>
					<Title title="Edit Floorplan" showDate={false} />
					<div className="content">
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							validateOnMount={true}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								//console.log(values)
								//return
								submitData("updateFloorplan", values).then((data) => {
									//return
									this.props.loadingStatus(false)
									toast.success(data.message)
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}>
							{(f) => (
								<div className="editCommunity">
									<Form>
										{console.log(f)}
										<ul className="form__list">
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("plan_number", f)}>
												<label htmlFor="plan_number">Plan Number</label>
												{f.errors.plan_number && f.touched.plan_number && (
													<div className="form__message">{f.errors.plan_number}</div>
												)}
												<Field name="plan_number" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("builder", f, false, false, false)}>
												<label htmlFor="builder">
													Builder <sup>*</sup>
												</label>
												{f.errors.builder && f.touched.builder && (
													<div className="form__message">{f.errors.builder}</div>
												)}
												<ReactSelect
													name={`builder`}
													options={_.map(this.props.payload.public.builders, (v) => {
														return {
															label: v.name,
															value: v.id,
														}
													})}
													value={f.values.builder}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("sqft", f)}>
												<label htmlFor="sqft">
													Square Feet<sup>*</sup>
												</label>
												{f.errors.sqft && f.touched.sqft && (
													<div className="form__message">{f.errors.sqft}</div>
												)}
												<NumberField
													name="sqft"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft}
													error={f.errors.sqft}
													value={f.values.sqft}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("stories", f)}>
												<label htmlFor="stories">
													Stories<sup>*</sup>
												</label>
												{f.errors.stories && f.touched.stories && (
													<div className="form__message">{f.errors.stories}</div>
												)}
												<NumberField
													name="stories"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.stories}
													error={f.errors.stories}
													value={f.values.stories}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("beds", f)}>
												<label htmlFor="beds">
													Beds<sup>*</sup>
												</label>
												{f.errors.beds && f.touched.beds && (
													<div className="form__message">{f.errors.beds}</div>
												)}
												<NumberField
													name="beds"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.beds}
													error={f.errors.beds}
													value={f.values.beds}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("full_baths", f)}>
												<label htmlFor="full_baths">
													Full Baths<sup>*</sup>
												</label>
												{f.errors.full_baths && f.touched.full_baths && (
													<div className="form__message">{f.errors.full_baths}</div>
												)}
												<NumberField
													name="full_baths"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.full_baths}
													error={f.errors.full_baths}
													value={f.values.full_baths}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("half_baths", f)}>
												<label htmlFor="half_baths">Half Baths</label>
												{f.errors.half_baths && f.touched.half_baths && (
													<div className="form__message">{f.errors.half_baths}</div>
												)}
												<NumberField
													name="half_baths"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.half_baths}
													error={f.errors.half_baths}
													value={f.values.half_baths}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("garage", f)}>
												<label htmlFor="garage">
													Garage<sup>*</sup>
												</label>
												{f.errors.garage && f.touched.garage && (
													<div className="form__message">{f.errors.garage}</div>
												)}
												<NumberField
													name="garage"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.garage}
													error={f.errors.garage}
													value={f.values.garage}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("properties", f)}>
												<label htmlFor="properties">Properties</label>
												{f.errors.properties && f.touched.properties && (
													<div className="form__message">{f.errors.properties}</div>
												)}
												<ReactSelect
													name={`properties`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { label: v.name, value: v.id }
													})}
													isMulti
													value={f.values.properties}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											{this.buildClassifications(f)}
											<li className={fieldStatus("manual_properties", f)}>
												<label htmlFor="manual_properties">Manual Properties</label>
												{f.errors.manual_properties && f.touched.manual_properties && (
													<div className="form__message">{f.errors.manual_properties}</div>
												)}
												<ReactSelect
													name={`manual_properties`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { label: v.name, value: v.id }
													})}
													isMulti
													value={f.values.manual_properties}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("status", f, false, false, false)}>
												<label htmlFor="status">
													Status <sup>*</sup>
												</label>
												{f.errors.status && f.touched.status && (
													<div className="form__message">{f.errors.status}</div>
												)}
												<ReactSelect
													name={`status`}
													options={[
														{
															label: "Disabled",
															value: 0,
														},
														{
															label: "Enabled",
															value: 1,
														},
													]}
													value={f.values.status}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("description", f)}>
												<label htmlFor="description">Description</label>
												{f.errors.description && f.touched.description && (
													<div className="form__message">{f.errors.description}</div>
												)}
												<TextArea
													name="description"
													className="form__textarea"
													value={f.values.description}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.description}
													error={f.errors.description}
												/>
											</li>
											<li className={fieldStatus("feed_name", f)}>
												<label htmlFor="feed_name">Feed Name</label>
												{f.errors.feed_name && f.touched.feed_name && (
													<div className="form__message">{f.errors.feed_name}</div>
												)}
												<Field name="feed_name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("feed_name_secondary", f)}>
												<label htmlFor="feed_name_secondary">Feed Name Secondary</label>
												{f.errors.feed_name_secondary && f.touched.feed_name_secondary && (
													<div className="form__message">{f.errors.feed_name_secondary}</div>
												)}
												<Field name="feed_name_secondary" type="text" className="form__input" />
											</li>
											{settings.arc && (
												<>
													<li className={fieldStatus("similar", f, false, false, false)}>
														<label htmlFor="similar">Similar</label>
														{f.errors.similar && f.touched.similar && (
															<div className="form__message">{f.errors.similar}</div>
														)}
														<ReactSelect
															name={`similar`}
															options={_.map(
																this.props.payload.public.floorplans,
																(v) => {
																	return {
																		label: v.name,
																		value: v.id,
																	}
																}
															)}
															value={f.values.similar}
															onBlur={f.setFieldTouched}
															onChange={f.setFieldValue}
															isMulti
														/>
													</li>
													<li className={fieldStatus("max_pad_depth", f)}>
														<label htmlFor="max_pad_depth">Max Pad Depth</label>
														{f.errors.max_pad_depth && f.touched.max_pad_depth && (
															<div className="form__message">
																{f.errors.max_pad_depth}
															</div>
														)}
														<NumberField
															name="max_pad_depth"
															className="form__input"
															onChange={f.setFieldValue}
															onBlur={f.setFieldTouched}
															touched={f.touched.max_pad_depth}
															error={f.errors.max_pad_depth}
															value={f.values.max_pad_depth}
															thousandSeparator={true}
															float={true}
														/>
													</li>
													<li className={fieldStatus("masonry_percent", f)}>
														<label htmlFor="masonry_percent">Masonry %</label>
														{f.errors.masonry_percent && f.touched.masonry_percent && (
															<div className="form__message">
																{f.errors.masonry_percent}
															</div>
														)}
														<NumberField
															name="masonry_percent"
															type="text"
															className="form__input"
															onChange={f.setFieldValue}
															onBlur={f.setFieldTouched}
															touched={f.touched.masonry_percent}
															error={f.errors.masonry_percent}
															value={f.values.masonry_percent}
															thousandSeparator={true}
														/>
													</li>
													<li className={fieldStatus("roof_pitch", f)}>
														<label htmlFor="roof_pitch">Roof Pitch</label>
														{f.errors.roof_pitch && f.touched.roof_pitch && (
															<div className="form__message">{f.errors.roof_pitch}</div>
														)}
														<Field name="roof_pitch" type="text" className="form__input" />
													</li>
													<li
														className={fieldStatus(
															"arc_review_notes",
															f,
															false,
															false,
															true
														)}>
														<label htmlFor="arc_review_notes">ARC Review Notes</label>
														{f.errors.arc_review_notes && f.touched.arc_review_notes && (
															<div className="form__message">
																{f.errors.arc_review_notes}
															</div>
														)}
														<TextArea
															name="arc_review_notes"
															className="form__textarea"
															value={f.values.arc_review_notes}
															onChange={f.setFieldValue}
															onBlur={f.setFieldTouched}
															touched={f.touched.arc_review_notes}
															error={f.errors.arc_review_notes}
														/>
													</li>
												</>
											)}
											<li className={fieldStatus("files", f, false, false, true)}>
												<label htmlFor="files">Images</label>
												{f.errors.files && f.touched.files && (
													<div className="form__message">{f.errors.files}</div>
												)}
												<Dropzone
													multiple={true}
													onDrop={(files) => {
														this.onDrop(files, f, "general")
													}}>
													{({ getRootProps, getInputProps }) => (
														<section className="dropzone">
															<div {...getRootProps()} className="dropbox__cont">
																<input {...getInputProps()} />
																<p className="dropzone__action">
																	Drag 'n' drop file here, or click to select files
																</p>
															</div>
														</section>
													)}
												</Dropzone>
											</li>
											<li className="form__listItem form__listItem--full">
												<div className="formFiles">
													<h3>General Images</h3>
													<div className="formFiles__listCont">
														{this.compileThumbs(f, "general")}
													</div>
												</div>
											</li>
											<li className={fieldStatus("blueprints", f, false, false, true)}>
												<label htmlFor="blueprints">Blueprints</label>
												{f.errors.blueprints && f.touched.blueprints && (
													<div className="form__message">{f.errors.blueprints}</div>
												)}
												<Dropzone
													multiple={false}
													onDrop={(blueprints) => {
														this.onDrop(blueprints, f, "blueprints")
													}}>
													{({ getRootProps, getInputProps }) => (
														<section className="dropzone">
															<div {...getRootProps()} className="dropbox__cont">
																<input {...getInputProps()} />
																<p className="dropzone__action">
																	Drag 'n' drop file here, or click to select
																	blueprints
																</p>
															</div>
														</section>
													)}
												</Dropzone>
											</li>
											<li className="form__listItem form__listItem--full">
												<div className="formFiles">
													<h3>Blueprint Images</h3>
													<div className="formFiles__listCont">
														{this.compileThumbs(f, "blueprints")}
													</div>
												</div>
											</li>
											<li className={fieldStatus("base_prices", f, false, false, true)}>
												<div className="reportGroup">
													<h3>Base Prices by Community</h3>
													<KeyValueField
														options={{
															key: {
																type: "select",
																lookup: "properties",
																header: "Property",
															},
															value: {
																type: "number",
																header: "Base Price",
															},
														}}
														data={f.values.base_prices}
														delete={true}
														onChange={(v) => f.setFieldValue("base_prices", v)}
													/>
												</div>
											</li>
											<li className={fieldStatus("lot_types", f, false, false, true)}>
												<div className="reportGroup">
													<h3>
														{settings.arc ? <span>Approved Lot Types &amp; </span> : ""}Base
														Prices By Lot Type + Community
													</h3>
													{settings.arc ? (
														<p className="text-sm text-red-500">
															Please note if a lot type is deleted it will remove it from
															the list of approved lot types for the builder.
														</p>
													) : (
														""
													)}

													<TableRowField
														fields={[
															{
																type: "select",
																name: "property",
																lookup: "properties",
																header: "Property",
															},
															{
																type: "select",
																name: "lot_type",
																lookup: "lot_types",
																header: "Lot Type",
																dependent: "property",
															},
															{
																type: "number",
																name: "base_price",
																header: "Base Price",
															},
															{
																type: "number",
																name: "manual_base_price",
																header: "Manual Base Price",
															},
														]}
														data={f.values.lot_types}
														delete={true}
														onChange={(v) => f.setFieldValue("lot_types", v)}
													/>
												</div>
											</li>
										</ul>
										{settings.arc && (
											<>
												<h2>Master Plans</h2>
												<div>
													<Link to={`/admin/floorplans/${this.state.id}/new-master`}>
														<p className="btn btn--square">Manually Add Master Plan</p>
													</Link>
												</div>
												<FullTable
													data={this.buildMasterPlans(f)}
													columns={this.state.masterCols}
													name="floorplan__masterPlans"
													title="Master Plans"
													classNames="showControls"
												/>
											</>
										)}
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						</Formik>
						{(settings.arc || settings?.arcThirdParty || settings?.enableElevations) &&
							this.props.payloadStatus && (
								<Formik
									enableReinitialize
									initialValues={this.state.elevationFields}
									onSubmit={async (values) => {
										this.props.loadingStatus(true)
										values.floorplan = parseInt(this.props.match.params.id)
										let data = await submitData("updateFloorplanElevations", values)
										//await this.props.getPayload() // causes infinite loop
										//this.props.loadingStatus(false)
										toast.success(data.message)
										location.reload() // see above, it was causing infintie loops, and there was some scenario where if you came back and we didn't refresh payload it would show old shit, so this is whatever
									}}>
									{(f) => (
										<div className="py-8 rounded-lg px-4 mt-8 border-2 border-dashed border-neutral-600">
											{/* console.log(f) */}
											<Form>
												<h2 className="p-0">Elevations</h2>
												<ul className="form__list">
													<li className={fieldStatus("elevations", f, false, false, true)}>
														<div className="">
															<TableRowField
																delete={true}
																debug={true}
																fields={[
																	{
																		type: "select",
																		name: "property",
																		lookup: "properties",
																		header: "Property",
																	},
																	{
																		type: "select",
																		name: "approval_status",
																		options: [
																			{ value: 0, label: "Not Approved" },
																			{ value: 1, label: "Approved" },
																		],
																		header: "Approval Status",
																	},
																	{
																		type: "text",
																		name: "name",
																		header: "Name",
																	},
																	{
																		type: "number",
																		name: "min_sqft",
																		header: "Min Sqft",
																		width: "7%",
																	},
																	{
																		type: "number",
																		name: "max_sqft",
																		header: "Max Sqft",
																		width: "7%",
																	},
																	...(this.props.payload.public
																		.floorplan_classifications?.length
																		? [
																				{
																					type: "select",
																					name: "style",
																					header: "Style",
																					width: "15%",
																					options:
																						this.props.payload.public.floorplan_classifications.map(
																							(v) => ({
																								value: v.id,
																								label: v.name,
																							})
																						),
																				},
																		  ]
																		: []),
																	{
																		type: "textarea",
																		name: "notes",
																		header: "Notes",
																	},
																]}
																data={f.values.elevations}
																onChange={(v) => f.setFieldValue("elevations", v)}
															/>
														</div>
													</li>
												</ul>
												<input
													type="submit"
													value="Submit"
													className={this.submitClasses(f.isValid)}
												/>
											</Form>
										</div>
									)}
								</Formik>
							)}
						<h2>Lots Assigned</h2>
						<FullTable
							data={this.buildLotsTable()}
							columns={this.state.lotCols}
							name="floorplan__lots"
							title="Floorplan - Lots"
							unset={["edit"]}
							pageSize={10}
						/>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditFloorplan)
